export class ApiError extends Error {
  status: number
  code: number
  constructor(message: string, status: number, code: number) {
    super(message)
    this.name = 'API Error'
    this.status = status
    this.code = code
  }
}
